// Silence the benign "ResizeObserver loop" notices.
//
// "ResizeObserver loop completed with undelivered notifications." (and its
// older sibling "ResizeObserver loop limit exceeded") is not an error: the
// browser ran an observer callback that changed layout and simply deferred the
// next batch to the following frame. Nothing is lost and nothing is visibly
// wrong. But react-error-overlay (dev) listens on window 'error' and turns it
// into a full-screen modal that intercepts every click — so a user who
// collapses the sidebar then cannot click anything to expand it again, because
// the invisible overlay is on top. simplebar's ResizeObserver fires it while
// the rail animates its width.
//
// We swallow ONLY those two messages, in the capture phase so we run before the
// overlay's own handler, and clear the webpack-dev-server overlay if it slipped
// through. Every other error still reaches the overlay untouched. In a
// production build there is no overlay, so this is a harmless no-op there.

const BENIGN = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded'
];

function isBenign(message) {
  return typeof message === 'string' && BENIGN.some((m) => message.includes(m));
}

if (typeof window !== 'undefined') {
  window.addEventListener(
    'error',
    (event) => {
      if (isBenign(event?.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
        const overlay = document.getElementById(
          'webpack-dev-server-client-overlay'
        );
        if (overlay) overlay.remove();
      }
    },
    true
  );

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    if (isBenign(typeof reason === 'string' ? reason : reason?.message)) {
      event.preventDefault();
    }
  });
}
